import { Grid, Group, Space, Tabs, Title, } from '@mantine/core'
import React, { useContext, useEffect, useState } from 'react'

import RiskCountriesSettings from './risk_countries_settings';
import ApproversSettings from './approvers_settings';
import CustomClaimsSettings from './custom_claims_settings';

import NavUpdateSettings from './nav_update';
import RefreshDataSettings from './refresh_data_settings';
import { MyUserDataContext } from '../../contexts';
import { CustomClaims } from '../../types';
import FirebaseGatewaySettings from './firebase_gateway';
import UploadTrades from './upload_trades';
import TradesSettings from './trades_settings';
import { GenevaSchemaConfigurator } from './geneva_schema_configurator';
import WhatsAppSettings from './whatsapp_settings';

const Settings = () => {
    const [activeTab, setActiveTab] = React.useState<string | null>();

    //get claims
    const userContext = useContext(MyUserDataContext);
    let userClaims = userContext.firebaseTokenResult?.claims.customClaims as CustomClaims || {};
    const [disabledTabs, setDisabledTabs] = useState<string[]>([])
    const allTabs = ["nav_settings", "risk_countries", "approve_settings", "claims_settings", "firebase_gateway", "data_settings", "geneva_schema"]
    useEffect(() => {
        let newTabs: string[] = []
        if (!userClaims.admin && !userClaims.oper) {
            newTabs.push("nav_settings")
            newTabs.push("upload_trades")
            newTabs.push("trades_settings")
        }
        if (!userClaims.cr && !userClaims.risk && !userClaims.admin && !userClaims.sys) {
            newTabs.push("risk_countries")
        }
        if (!userClaims.admin && !userClaims.sys) {
            newTabs.push("approve_settings", "claims_settings");

        }
        if (!userClaims.admin) {
            newTabs.push("firebase_gateway", "data_settings", "geneva_schema", "whatsapp_settings");
        }
        setDisabledTabs(disabledTabs);
        setActiveTab(allTabs.filter((tabValue) => !newTabs.includes(tabValue))[0])
    }, [userClaims])


    return (
        <main style={{ padding: "1rem 0" }}>


            <Group justify="space-between">
                <Title>Update Settings</Title>
            </Group>

            <Space h="xl" />

            <Grid gap="md">

                <Grid.Col span={{ xs: 12 }}>
                    <Tabs onChange={setActiveTab} value={activeTab}>
                        <Tabs.List>
                            <Tabs.Tab disabled={disabledTabs.includes("nav_settings")} value="nav_settings">Nav Settings</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("upload_trades")} value="upload_trades">Upload Trades</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("risk_countries")} value="risk_countries">Risk Countries</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("approve_settings")} value="approve_settings">Approval settings</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("claims_settings")} value="claims_settings">Claims settings</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("whatsapp_settings")} value="whatsapp_settings">WhatsApp Settings</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("data_settings")} value="data_settings">Data settings</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("firebase_gateway")} value="firebase_gateway">Firebase Gateway</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("trades_settings")} value="trades_settings">Trades Settings</Tabs.Tab>
                            <Tabs.Tab disabled={disabledTabs.includes("geneva_schema")} value="geneva_schema">Geneva Schema</Tabs.Tab>
                        </Tabs.List>

                        <Space h="xl" />

                        <Tabs.Panel value="nav_settings">
                            <NavUpdateSettings />
                        </Tabs.Panel >

                        <Tabs.Panel value="risk_countries">
                            <RiskCountriesSettings />
                        </Tabs.Panel >

                        <Tabs.Panel value="approve_settings">
                            <ApproversSettings />
                        </Tabs.Panel >

                        <Tabs.Panel value="claims_settings">
                            <CustomClaimsSettings />
                        </Tabs.Panel >

                        <Tabs.Panel value="whatsapp_settings">
                            <WhatsAppSettings />
                        </Tabs.Panel >

                        <Tabs.Panel value='data_settings'>
                            <RefreshDataSettings />
                        </Tabs.Panel>

                        <Tabs.Panel value='firebase_gateway'>
                            <FirebaseGatewaySettings />
                        </Tabs.Panel>

                        <Tabs.Panel value='upload_trades'>
                            <UploadTrades />
                        </Tabs.Panel>

                        <Tabs.Panel value='trades_settings'>
                            <TradesSettings />
                        </Tabs.Panel>

                        <Tabs.Panel value='geneva_schema'>
                            <GenevaSchemaConfigurator />
                        </Tabs.Panel>

                    </Tabs >
                </Grid.Col>










            </Grid>


        </main>
    )
}

export default Settings
